import { Trans } from '@lingui/react/macro'

import { SelectGuests } from '@/features/guest'
import GuestTable from './GuestTable'

interface Props {
  value: number[]
  onChange: (newValue: number[]) => void
  name?: string
  invalid?: boolean
  disabled?: boolean
  readOnly?: boolean
}

export default function GuestsField({
  value,
  onChange,
  name,
  invalid,
  readOnly,
  disabled
}: Props) {
  return (
    <fieldset className="flex flex-1 flex-col gap-2.5">
      <div className="flex flex-row items-center justify-between gap-2">
        <label className="text-heading3 text-text">
          <Trans>Guests of this stay</Trans>
        </label>
        {!readOnly && (
          <SelectGuests
            ids={value}
            onChange={onChange}
            name={name}
            invalid={invalid}
            disabled={disabled}
            readOnly={readOnly}
          />
        )}
      </div>
      <GuestTable ids={value} />
    </fieldset>
  )
}
